module.exports = __webpack_public_path__ + "static/media/nightlife.e4c3ae45.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Calculator/icons/nightlife.png
// module id = 555
// module chunks = 0